import CovidFAQ from './CovidFaq.js';
import FAQ from './TwoColumnPrimaryBackground.js';

export {CovidFAQ};
export default FAQ;